import { isQuestionCategoryVisible } from './isQuestionCategoryVisible';
import { isQuestionCategorySubscribable } from './isQuestionCategorySubscribable';

export function isQuestionCategoryPostable(category) {
    return isQuestionCategoryVisible(category) || (isQuestionCategorySubscribable(category) && category.subscribed);
}
